import { inject, injectable } from 'inversify';
import { TYPES } from './iocTypes';
import type { Tools, ToolStateStore } from './ToolStateStore';

@injectable()
export class ToolSelectorController {
  private _toolStateStore: ToolStateStore;

  public constructor(@inject(TYPES.ToolStateStore) toolStateStore: ToolStateStore) {
    this._toolStateStore = toolStateStore;
  }

  public isSelected(tool: Tools): boolean {
    return this._toolStateStore.currentTool === tool;
  }

  public setCurrentTool(tool: Tools): void {
    this._toolStateStore.setCurrentTool(tool);
  }
}
